export const TERMINAL_VELOCITY_MIN = 3;
export const TERMINAL_VELOCITY_MAX = 15;

function debugEnabled(search: string): boolean {
  const params = new URLSearchParams(search);
  return params.get('debug') === '1' || params.get('e2e') === '1';
}

function clampAndRound(value: number): number {
  const clamped = Math.min(TERMINAL_VELOCITY_MAX, Math.max(TERMINAL_VELOCITY_MIN, value));
  return Math.round(clamped * 100) / 100;
}

export function initialDebugTerminalVelocity(search: string, fallback: number): number {
  if (!debugEnabled(search)) return fallback;
  const requested = Number(new URLSearchParams(search).get('terminalVelocity'));
  return Number.isFinite(requested) && requested > 0 ? clampAndRound(requested) : fallback;
}
